import { Table } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { Project } from '@work4all/models/lib/Classes/Project.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { OrganisationArea } from '../../../organisation-area';
import { TableAreas } from '../../table/EntityTableLayoutV8';

import { useProjectBottomArea } from './use-project-bottom-area';

interface IProps {
  selectedProjectList: Project[];
  selectedRessourceClassCell?: { ressourceClass: LookUp; project: Project };
  date: Date;
  selectedUtilizationUserIds?: number[];
  table: Table<unknown>;
  showBottomArea?: boolean;
}

export const useProjectTableAreas = (props: IProps) => {
  const {
    selectedProjectList,
    selectedRessourceClassCell,
    date,
    selectedUtilizationUserIds,
    table,
    showBottomArea = true,
  } = props;

  const { t } = useTranslation();

  const bottomArea = useProjectBottomArea({
    selectedEntities: selectedProjectList,
    selectedRessourceClassCell,
    date,
    onDateChange: () => null,
    selectedUtilizationUserIds,
  });

  return useMemo<TableAreas>(() => {
    return {
      left: {
        title: t('COMMON.ORGANISATION'),
        content: <OrganisationArea entity={Entities.project} table={table} />,
        resizable: true,
        collapsible: true,
        custom: true,
      },
      bottom: showBottomArea ? bottomArea : undefined,
    };
  }, [bottomArea, showBottomArea, t, table]);
};
